import React from 'react';

export default function NoneLayout(props: { children: React.ReactNode }) {
    return (
        <>
            {props.children}
        </>
    );
}